var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-input"},[_c('i',{staticClass:"fas fa-search"}),_vm._v(" "),_c('input',{staticClass:"product-search",attrs:{"type":"text","placeholder":"find your wine"},on:{"keyup":_vm.search}})])}
var staticRenderFns = []

export { render, staticRenderFns }